import React from 'react';
import { Column } from '../../hooks/useTablePages';
import { format } from 'date-fns';

const columns: Column[] = [
  {
    header: 'Type',
    accessor: 'type',
    width: 300,
  },
  {
    header: 'Subject',
    accessor: 'subject',
    width: 600,
  },
];

export const archivedColumns: Column[] = [
  ...columns,
  {
    header: 'Archived',
    id: 'archived',
    accessor: (row) => {
      return format(row.archived, 'M/d/yyyy');
    },
    width: 100,
  },
];

export default columns;
